// extracted by mini-css-extract-plugin
module.exports = {"photo_delete":"PhotoDelete_photo_delete__3sp2T"};